<script>
  import { onDestroy, onMount } from 'svelte'
  import { language, formatI18nDate, t } from '../../i18n/i18n'
  import { locationStore, signatureBlockStore, userStore, workLogStore } from '../../state/store'
  import { isUserAdmin } from './../../helpers/utils'
  import { getWorkLogs, getLocationData, getClientData, getPeopleData } from './../../state/actions'
  import SignatureBox from '../../components/SignatureBox.svelte'
  import Spinner from '../../components/Spinner.svelte'

  //Gets named parameters from Router
  export let params = {}

  import Button from '../../components/Button.svelte'
  import ViewContainer from '../../components/ViewContainer.svelte'
  import LocationHeader from './Location.header.svelte'
  import Breadcrumbs from '../../components/Breadcrumbs.svelte';

  // Location Id from url
  $: loc = {}
  let promise
  let unsub

  const openSignatureBlock = (id) => signatureBlockStore.set({ isOpen: true, id })

  let promiseArray = [getWorkLogs(params.id)]

  onMount(() => {
    if(!$locationStore.length) {
      promiseArray.concat(getLocationData())
    }
    if(isUserAdmin($userStore)) {
      promiseArray.concat([getClientData(), getPeopleData()])
    }
    promise = Promise.all(promiseArray)
    unsub = locationStore.subscribe(locations => {
      loc = locations.find(l => l._id === params.id)
    })
  })

  onDestroy(() => unsub())
</script>

<style>

  img {
    max-width: 12rem;
    height: auto;
  }

  .log-button {
    margin: 2rem 0;
  }

  .note {
    grid-column: 1 / -1;
  }

  .note p {
    text-overflow: initial;
    overflow: visible;
    white-space: initial;
  }

</style>

{#await promise}
  <Spinner />
{:then}
  <ViewContainer>
    {#if loc}
      <Breadcrumbs current={loc.name}></Breadcrumbs>
    {/if}
    <section class="g-detail-page">
      {#if loc}
        <LocationHeader {loc} /> 
      {/if}
      <div>
        <div class='mobile-only log-button'>
          <Button size='full' on:click={() => openSignatureBlock(loc._id)}>{$t.log_work}</Button>
        </div>
        <h2>{$t['Location Logs']}</h2>
        <article class="g-card-list-wrapper">
          {#if $workLogStore.length === 0}
            <div>
              <p>{$t.no_logs}</p>
            </div>
          {:else}
            {#each $workLogStore as data, index}
                <ul class='g-card-list'
                on:click={() => window.open(`https://www.google.com/maps/search/?api=1&query=${data.coordinates[1]},${data.coordinates[0]}`)}>
                  {#each Object.entries(data) as [key, val]}
                    {#if key === 'name'}
                      <li>
                        <p>{$t[key]}</p>
                        <p>{val}</p>
                      </li>
                    {/if}
                    {#if key === 'time_stamp'}
                      <li>
                        <p>{$t[key]}</p>
                        <p>{formatI18nDate($language, val)}</p>
                        <p>{new Date(val).toLocaleTimeString($language)}</p>
                      </li>
                    {/if}
                    {#if key === 'signature' && isUserAdmin($userStore) }
                      <li>
                        <p>{$t[key]}</p>
                        <img src={val} alt="signature">
                      </li>
                    {/if}
                    {#if key === 'assignee' && isUserAdmin($userStore) }
                      <li>
                        <p>{$t[key]}</p>
                        <p>{val}</p>
                      </li>
                    {/if}
                    {#if key === 'note' && val.length > 0 }
                      <li class="note">
                        <p>{$t['Notes']}</p>
                        <p>{val}</p>
                      </li>
                    {/if}
                  {/each}
                </ul>
            {/each}
            {/if}
        </article>
      </div>
    </section>

    {#if $signatureBlockStore.isOpen}
      <SignatureBox locationId={loc._id} clientId={loc.client} />
    {/if}
  </ViewContainer>

{/await}